import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// sections
import Form from './Form';
// components
import Breadcrumbs from '../../../components/breadcrumbs';
import SearchField from '../../../components/search-field';
import Pagination from '../../../components/pagination';
import { Popover } from 'devextreme-react/popover';
import { Dialog } from '../../../components/dialog';
// @devextreme
import DataGrid, { Column } from 'devextreme-react/data-grid';
// styles
import { Content, Box, AffiliatedTitle, SearchWrapper, AddButton, TableMoreButton } from '../../../styles';
// apis
import { getRegisteredSoils, deleteSoils } from '../../../apis';

// ----------------------------------------------------------------------

const sizes = [ 20, 30 ];

// ----------------------------------------------------------------------

export default function CompanySoilPage() {
  const navigate  = useNavigate();

  const state = useLocation().state;
  const company = { id: state?.id, name: state?.name };

  const [ data, setData ] = useState({ content: [], totalPages: 0 });
  const { content: rows, totalPages: pages } = data;

  const [ keyword, setKeyword ] = useState('');
  const [ page, setPage ] = useState(0);
  const [ size, setSize ] = useState(20);
  
  const [ dialog, setDialog ] = useState({
    form: { visible: false },
    delete: { visible: false }
  });

  const [ message, setMessage ] = useState(null);

  useEffect(() => {
    if ( !state ) return navigate(-1);
    ( async () =>
      await getRegisteredSoils(setData, company.id, keyword, page, size)
    )();
    // eslint-disable-next-line
  }, [state]);

  const handlePage = (value) => {
    setPage(value - 1);
    getRegisteredSoils(setData, company.id, keyword, value-1, size);
  };

  const handleSize = (event) => {
    setPage(0);
    setSize( Number(event.target.value) );
    getRegisteredSoils(setData, company.id, keyword, 0, Number(event.target.value));
  };

  const handleSearch = () => {
    setPage(0);
    getRegisteredSoils(setData, company.id, keyword, 0, size);
  };

  const handleDelete = async () => {
    await deleteSoils(company.id, dialog.delete.id)
      .then(() => {
        handleSearch();
        setDialog({ ...dialog,
          delete: { visible: false }
        });
      })
      .catch(() => {
        setMessage('토양 그룹을 삭제할 수 없습니다. 나중에 다시 시도해 주세요.');
      });
  };

  const cellRender = ({data}) => {
    return <TableRow row={data} dialog={dialog} setDialog={setDialog} />;
  };

  if ( !state ) return;

  return (
    <Content>
      <Breadcrumbs
        heading='토양 그룹 설정'
        links={[
          { name: '시스템 관리' },
          { name: '기업 관리', link: '/system/company' },
          { name: '토양 그룹 설정' }
        ]}
      />

      <Box>
        <AffiliatedTitle>
          <p>{ company.name }</p>
        </AffiliatedTitle>

        <SearchWrapper>
          <SearchField
            value={keyword}
            onChange={setKeyword}
            handleSearch={handleSearch}
            handleInitialize={handleSearch}
            placeholder='그룹명을 입력하세요.'
          />
          <AddButton onClick={() => {
            setDialog({ ...dialog,
              form: {
                visible: true,
                id: company.id
              }
            });
          }}>
            추가
          </AddButton>
        </SearchWrapper>

        <DataGrid
          dataSource={rows}
          noDataText=''
          columnAutoWidth={true}
        >
          <Column caption='그룹' dataField='name' alignment='center' />
          <Column caption='설명' dataField='description' alignment='center' />
          <Column caption='등록일' dataField='createdAt' alignment='center' />
          <Column caption='' dataField='id' cellRender={cellRender} alignment='center' />
        </DataGrid>

        <Pagination page={page} pages={pages} handlePage={handlePage} size={size} sizes={sizes} handleSize={handleSize} />

        { dialog.form.visible &&
          <Form dialog={dialog} setDialog={setDialog} handleReset={handleSearch} />
        }

        { dialog.delete.visible &&
          <Dialog
            title='토양 그룹 삭제'
            icon='delete'
            message={ message }
            actions={
              <div>
                <button onClick={() => handleDelete()}>
                  삭제
                </button>
                <button onClick={() => {
                  setDialog({ ...dialog,
                    delete: { visible: false }
                  });
                  setMessage(null);
                }}>
                  취소
                </button>
              </div>
            }
          >
            <p>선택하신 토양 그룹을 삭제하시겠습니까?</p>
          </Dialog>
        }
        
      </Box>
    </Content>
  );
}

function TableRow({ row, dialog, setDialog }) {
  const [ visible, setVisible ] = useState(false);
  
  return (
    <>
      <TableMoreButton id={`more${row.id}`} onClick={() => setVisible(true)} />

      <Popover
        target={`#more${row.id}`}
        visible={visible}
        hideOnOutsideClick={true}
        onHiding={() => setVisible(false)}
        position='left'
      >
        <button
          onClick={() => {
            setDialog({ ...dialog,
              delete: {
                visible: true,
                id: row.id
              }
            });
            setVisible(false);
          }}
        >
          삭제
        </button>
      </Popover>
    </>
  );
}